function NoOrganizationsCtrl($scope, $state, authService) {
  _initScope();

  function _initScope() {
    $scope.backToLogin = _backToLogin;
  }

  function _backToLogin($event) {
    if ($event) $event.preventDefault();

    authService.logout();

    $state.go('login');
  }
}

NoOrganizationsCtrl.$inject = [
  '$scope',
  '$state',
  'authService'
];

export default NoOrganizationsCtrl;



// WEBPACK FOOTER //
// ./src/components/noOrganizations/noOrganizationsCtrl.js